var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_126_1072)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.0001,
    width: 70,
    height: 48,
    rx: 15.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3511 57.612C71.8884 57.612 77.9986 51.4309 77.9986 43.8061C77.9986 36.1812 71.8884 30.0001 64.3511 30.0001C60.9732 30.0001 57.8819 31.2415 55.4988 33.298C53.1157 31.2416 50.0244 30.0001 46.6466 30.0001C39.1092 30.0001 32.999 36.1813 32.999 43.8061C32.999 51.4309 39.1092 57.6121 46.6466 57.6121C50.0245 57.6121 53.1157 56.3706 55.4988 54.3142C57.882 56.3706 60.9732 57.612 64.3511 57.612Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4989 54.3142C58.4335 51.782 60.2943 48.0138 60.2943 43.8061C60.2943 39.5983 58.4335 35.8302 55.4989 33.2979C57.882 31.2415 60.9732 30.0001 64.3511 30.0001C71.8884 30.0001 77.9986 36.1812 77.9986 43.8061C77.9986 51.4309 71.8884 57.612 64.3511 57.612C60.9732 57.612 57.882 56.3706 55.4989 54.3142Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4995 54.3143C58.434 51.782 60.2948 48.0139 60.2948 43.8061C60.2948 39.5984 58.434 35.8302 55.4995 33.298C52.5649 35.8302 50.7041 39.5984 50.7041 43.8061C50.7041 48.0139 52.5649 51.782 55.4995 54.3143Z",
    fill: "#FF5E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_126_1072",
    x: 0,
    y: 0.00012207,
    width: 110,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_1072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_1072",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.e490efa3eb015a948d5bea3d2f6df8f4.svg";
export { ForwardRef as ReactComponent };